/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: 'logibids-Noauto',
})
export class AutocompleteOffDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'off');
  }
}
